import { render, staticRenderFns } from "./HCDashboard.vue?vue&type=template&id=7231984a&scoped=true&"
import script from "./HCDashboard.vue?vue&type=script&lang=js&"
export * from "./HCDashboard.vue?vue&type=script&lang=js&"
import style0 from "./HCDashboard.vue?vue&type=style&index=0&id=7231984a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7231984a",
  null
  
)

export default component.exports